import React, {Component} from 'react';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import {buildTimelineItem} from './change-request-detail-sheet';
import {sanitizeChangeControl} from '../util/change-control-text';

function titlecase(s) {
  return s ? s.charAt(0) + s.slice(1).toLowerCase() : '';
}

// The complete lifecycle history for one field: applied dd_version_control versions
// MERGED with the drift/decision/live-check events of every change request that touched
// it (#595). Reuses the change-request detail sheet's drawer chrome + timeline style, so
// the field drawer matches the "Change history" shown during the review process.
class FieldVersionHistorySheet extends Component {
  render() {
    const {open, onClose, entity, timeline, isLoading} = this.props;

    const schemaName = entity && entity.schema_name;
    const objectName = entity && entity.object_name;
    const columnName = entity && entity.column_name;
    const entityType = entity && (entity.entity_type || '').toUpperCase();
    const events = timeline || [];

    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        className="change-detail-sheet"
        ModalProps={{keepMounted: true, disableScrollLock: true}}
        PaperProps={{style: {width: '42%', minWidth: '480px'}}}
        data-testid="cc-fvh-drawer"
      >
        <div className="detail-sheet-container">
          <div className="detail-sheet-header">
            <div className="detail-sheet-header-content">
              <div className="detail-sheet-title">
                <div className="title-with-type">
                  <h2>{schemaName ? schemaName + ' · ' : ''}{objectName} › {columnName}</h2>
                  <div className="status-chips">
                    <Chip label={entityType || 'COLUMN'} size="small" className="status-chip chip-grey" />
                  </div>
                </div>
              </div>
              <div className="detail-sheet-actions">
                <IconButton onClick={onClose} size="small" title="Close" data-testid="cc-fvh-close">
                  <i className="material-icons">close</i>
                </IconButton>
              </div>
            </div>
          </div>

          <div className="detail-sheet-content">
            <div className="detail-sheet-info">
              <div className="info-item-row"><span className="info-label">Schema</span><span className="info-value">{schemaName || 'N/A'}</span></div>
              <div className="info-item-row"><span className="info-label">Object</span><span className="info-value">{objectName || 'N/A'}</span></div>
              <div className="info-item-row"><span className="info-label">Field</span><span className="info-value">{columnName || 'N/A'}</span></div>
              <div className="info-item-row"><span className="info-label">Type</span><span className="info-value">{entityType || 'COLUMN'}</span></div>

              <Divider />

              <div className="detail-section" data-testid="cc-fvh-timeline">
                <h3>Change history</h3>
                {isLoading ? (
                  <p className="diff-empty">Loading…</p>
                ) : events.length > 0 ? (
                  <ul style={{listStyle: 'none', margin: 0, padding: '0 0 0 8px', borderLeft: '2px solid #eceff1'}}>
                    {events.map((ev, idx) => {
                      // Applied-version rows are marked with a distinct teal dot and titled by
                      // their change type; all other events reuse the detail sheet's mapper.
                      const item = ev.kind === 'VERSION' ?
                        {color: '#00838f', title: `${ev.changeType ? titlecase(ev.changeType) + ' · ' : ''}v${ev.version_number}`, detail: sanitizeChangeControl(ev.detail)} :
                        buildTimelineItem(ev);
                      return (
                        <li
                          key={idx}
                          data-testid={'cc-fvh-item-' + idx}
                          style={{position: 'relative', padding: '0 0 18px 20px'}}
                        >
                          <span style={{position: 'absolute', left: -7, top: 4, width: 12, height: 12, borderRadius: '50%', background: item.color, border: '2px solid #fff'}} />
                          <div style={{fontWeight: 600, fontSize: 13, color: '#37474f'}}>{item.title}</div>
                          {item.detail && <div style={{fontSize: 12.5, color: '#546e7a', marginTop: 2}}>{item.detail}</div>}
                          <div style={{fontSize: 11.5, color: '#90a4ae', marginTop: 2}}>
                            {ev.at ? new Date(ev.at).toLocaleString() : ''}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <p className="diff-empty">No change history for this field.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default FieldVersionHistorySheet;
